import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import AboutUsPage from './pages/AboutUsPage';
import HomePage from './pages/HomePage';
import ServicePage from './pages/ServicePage';
import SolarCalculator from './pages/SolarCalculator';
import BlogPage from "./pages/BlogPage";
import ContactForm from './components/forms/ContactUs';
import { ContactFormProvider } from './contexts/ContectFormProvider';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Sitemap from './pages/SiteMap';
import { useEffect } from 'react';
function App() {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}, [location.pathname]);

  return (
    <HelmetProvider>
      <div className="App">
        <Navbar />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path='/solar-calculator' element={<SolarCalculator/>}/>
          <Route path='/blogs' element={<BlogPage/>}/>
          <Route path="/contact" element={
            <ContactFormProvider>
             <ContactForm/>
            </ContactFormProvider>}/>
          <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/sitemap' element={<Sitemap/>}/>

        </Routes>

        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
